import React from 'react';
import { Clock, PauseCircle } from '../../../../shared/assets/AppIcons';
import { Button } from '@/shared/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/dialog';

export default function PauseAutomationDialog({
  open,
  onOpenChange,
  automation,
  expirationDate,
  onConfirm,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-xl">
            <PauseCircle className="text-[var(--warning-text)]" size={16} />
            Metti in Pausa
          </DialogTitle>
        </DialogHeader>

        <div className="mt-4 space-y-4">
          <div className="bg-[var(--surface-raised)] border border-[var(--border)] rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <span className="text-sm text-[var(--text-secondary)]">Automazione</span>
              <span className="font-semibold text-[var(--text-primary)]">{automation?.nome}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-[var(--text-secondary)]">Servizio attivo fino al</span>
              <span className="font-semibold text-[var(--success-text)]">{expirationDate}</span>
            </div>
          </div>

          <div className="bg-[var(--warning-soft)] border border-[var(--warning-border)] rounded-lg p-3">
            <div className="flex items-start gap-2">
              <Clock className="text-[var(--warning-text)] mt-0.5" size={16} />
              <div>
                <p className="text-sm font-medium text-[var(--warning-text)]">Cosa succede se annulli il rinnovo?</p>
                <p className="text-xs text-[var(--warning-text)] mt-1">
                  Il servizio rimarra attivo fino al <strong>{expirationDate}</strong>. Dopo questa data, l'automazione non verra piu rinnovata automaticamente.
                </p>
              </div>
            </div>
          </div>

          <p className="text-sm text-[var(--text-secondary)] text-center">
            Sei sicuro di voler annullare il rinnovo automatico?
          </p>

          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Mantieni Rinnovo
            </Button>
            <Button className="bg-[var(--warning)] hover:bg-[var(--warning)]" onClick={onConfirm}>
              <PauseCircle size={16} className="mr-2" />
              Annulla Rinnovo
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
